<template>
  <div class="config" v-if="isDevelopment" @click="configClick" v-closable="closeConfig">
    <span class="config__emoji">{{ emoji }}</span>
    <!-- <span class="config__mode"> {{ Config.mode }} build </span> -->
    <transition name="drop-out">
      <div class="config__tooltip" v-show="isVisible">
        <h4>Config</h4>
        {{ Config }}
      </div>
    </transition>
  </div>
</template>

<script>
import { Config, isDevelopment } from '@/config';

export default {
  name: 'SidebarConfig',
  data: () => ({ Config, isVisible: false }),
  methods: {
    configClick() {
      this.isVisible = !this.isVisible;
    },
    closeConfig() {
      this.isVisible = false;
    },
  },
  computed: {
    emoji() {
      switch (this.Config.mode) {
        case 'development':
          return '🚧';
        case 'staging':
          return '🚀';
        default:
          return '🌍';
      }
    },
    isDevelopment,
  },
};
</script>

<style lang="scss" scoped>
.config {
  display: flex;
  align-self: center;
  color: $color-neutral;
  font-size: 12px;
  font-weight: 600;
  white-space: pre-wrap;
  padding: 8px;
  margin: 17px 17px 0px 17px;
  border: 1px solid $color-border;
  border-radius: $border-radius-round;
  width: 35px;
  height: 35px;

  &__emoji {
    cursor: pointer;
    margin-right: 8px;
    opacity: 0.6;
  }

  &__tooltip {
    background: $color-normal;
    border-radius: $border-radius-small;
    box-shadow: $shadow-tooltip;
    color: $color-white;
    font-size: 12px;
    padding: 16px;
    position: absolute;
    left: 52px;
    bottom: 92px;
    width: 500px;
    z-index: $top-index;
  }

  @media screen and (max-width: 1080px) {
    margin: 24px;

    &__tooltip {
      bottom: 52px;
    }
  }
}
</style>
